import { App } from 'vue';
import { useStringFunctions } from './useStringFunctions';

type ToastTypes = 'success' | 'notice' | 'warning' | 'error';

export const useLegacyToastInterceptor = (appInstance: App) => {
  const { isEmptyString } = useStringFunctions();

  const toastmessage = (type: ToastTypes, message: string, renderHtml: boolean = true) => {

    if ((type as ToastTypes & { stayTimeNotice: number }).stayTimeNotice) return;
    if (isEmptyString(message, true)) return;

    const toast = appInstance.config.globalProperties.$toast;

    let severity: 'success' | 'error' | 'info' | 'warn';
    let lifeDuration = 3000;

    switch (type) {
      case 'success':
        severity = 'success';
        break;
      case 'warning':
        severity = 'warn';
        lifeDuration *= 3;
        break;
      case 'error':
        severity = 'error';
        lifeDuration = null;
        break;
      default:
        severity = 'info';
        lifeDuration *= 2;
        break;
    }

    if (renderHtml) {
      toast.add({
        severity: severity, detail: message, life: lifeDuration, group: 'legacy-html-toast',
      });
    } else {
      toast.add({
        severity: severity, detail: message, life: lifeDuration,
      });
    }
  };

  function jqueryFake() {
    return { toastmessage: toastmessage };
  }

  jqueryFake.toastmessage = toastmessage;

  if (!window.$) {
    window.$ = jqueryFake;
    window.jQuery = jqueryFake;
  }

  const interceptInRealJquery = (jqueryInstance: any) => {
    jqueryInstance.toastmessage = toastmessage;
  };

  return { interceptInRealJquery };
};
